import { render, staticRenderFns } from "./EmissionImport.vue?vue&type=template&id=cf1e8cc8&scoped=true&"
import script from "./EmissionImport.vue?vue&type=script&lang=js&"
export * from "./EmissionImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1e8cc8",
  null
  
)

export default component.exports